import styled from 'styled-components';
import { StyledDiv } from '../../../Theme/CommonStyled';

export const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const StyledModalContent = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colors.mainBackground};
  border-radius: ${({ theme }) => theme.radii.xl};
  padding: 24px;
  max-width: 400px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: ${({ theme }) => theme.shadows.modal};
`;

export const StyledModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const StyledModalBody = styled.div`
  margin-bottom: 20px;
`;

export const StyledModalFooter = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
`;

export const StyledInstallButton = styled.button<{ width?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primaryGreen};
  color: white;
  border: none;
  border-radius: ${({ theme }) => theme.radii.lg};
  padding: 12px 24px;
  font-size: ${({ theme }) => theme.fontSizes[4]};
  font-weight: ${({ theme }) => theme.fontWeights[6]};
  cursor: pointer;
  transition: background-color 0.2s;
  width: ${({ width }) => width || 'auto'};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryGreenHover};
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const StyledCloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
  }
`;

export const StyledBrandInfo = styled(StyledDiv)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
`;
